import React from "react";
import PropTypes from "prop-types";
import "@css/Loader.css";
import MenuSkeleton from "./MenuSkeleton";
import * as Sentry from '@sentry/react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch( error, errorInfo ) {
        const id = Sentry.captureReactException( error, errorInfo );
        Sentry.showReportDialog( {
            eventId: id,
            labelName: "Имя пользователя",
            labelEmail: "Email",
            labelComments: "Что вы делали, когда произошла ошибка?",
            labelClose: "Закрыть",
            labelSubmit: "Отправить",
            subtitle: "Мы получили сообщение об этой ошибке и постараемся её исправить.",
            subtitle2: "Если хотите, вы можете оставить комментарий ниже.",
            errorGeneric: "Произошла ошибка при отправке отчёта об ошибке.",
            errorFormEntry: "Пожалуйста, заполните все обязательные поля.",
            successMessage: "Спасибо за ваш отзыв!",
        });
        this.setState({ error, errorInfo });
        if (this.props.onError) {
            this.props.onError(error, errorInfo);
        }
        // Optionally log to an external service here
    }

    COPY_FEEDBACK_DURATION_MS = 2000;

    handleCopy = async () => {
        const { error, errorInfo } = this.state;
        const text = `${error?.toString() || "Unknown error"}\n\n${
            errorInfo?.componentStack || ""
        }`;
        try {
            await navigator.clipboard.writeText(text);
            this.setState({ copied: true });
            setTimeout(() => this.setState({ copied: false }), this.COPY_FEEDBACK_DURATION_MS);
        } catch (e) {
            // Fallback for environments without clipboard API
            console.error("Clipboard copy failed", e);
            const ta = document.createElement("textarea");
            ta.value = text;
            ta.setAttribute("readonly", "");
            ta.style.position = "absolute";
            ta.style.left = "-9999px";
            document.body.appendChild(ta);
            ta.select();
            // As programmatic copy may be restricted, instruct user to copy manually
            // This ensures no deprecated APIs are used
            globalThis.alert("Скопируйте выделенный текст сочетанием Ctrl+C");
            this.setState({ copied: true });
            setTimeout(() => this.setState({ copied: false }), this.COPY_FEEDBACK_DURATION_MS);
            ta.remove();
        }
    };

    render() {
        if (!this.state.hasError) {
            return this.props.children;
        }

        const { error, errorInfo, copied } = this.state;

        return (
            <div className="full-page-loader">
                <MenuSkeleton />
                <div className="loader-content">
                    <div className="error-icon" aria-hidden>!</div>
                    <p className="loader-text" role="alert">
                        Произошла ошибка при отображении страницы
                    </p>
                    <div className="error-card">
                        <div className="error-header">
                            <span className="error-title">
                                {error?.message || error?.toString() || "Неизвестная ошибка"}
                            </span>
                            <div className="error-actions">
                                <button
                                    type="button"
                                    className="error-btn"
                                    onClick={this.handleCopy}
                                >
                                    {copied ? "Скопировано" : "Скопировать стек"}
                                </button>
                                <button
                                    type="button"
                                    className="error-btn secondary"
                                    onClick={() => globalThis.location.reload()}
                                >
                                    Обновить страницу
                                </button>
                                <button
                                    type="button"
                                    className="error-btn secondary"
                                    onClick={ () => globalThis.location.href = '/' }
                                >
                                    На главную
                                </button>
                            </div>
                        </div>
                        <details className="error-details">
                            <summary>Показать детали</summary>
                            <pre className="error-stack">{`${error?.toString() || ""}\n\n${errorInfo?.componentStack || ""}`}</pre>
                        </details>
                    </div>
                </div>
            </div>
        );
    }
}

ErrorBoundary.propTypes = {
    children: PropTypes.node,
    onError: PropTypes.func,
};

export default ErrorBoundary;
